import { LoadingModule } from './pages/loading/loading.module';
import { AddressCityComponentModule } from './address/pages/address-city/address-city.module';
import { AddressStateComponentModule } from './address/pages/address-state/address-state.module';
import { NiftModule } from './income-wealth/pages/nif/nif.module';
import { TaxResidencyCountryComponentModule } from './income-wealth/pages/tax-residency-country/tax-residency-country.module';
import { TaxResidencyPageModule } from './income-wealth/pages/tax-residency/tax-residency.module';
import { BrowserModule, Title } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { RouterGuard } from './shared/service/router-guard/router-guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentTypeComponentModule } from './personal-data/pages/document-type/document-type.module';
import { DocumentNameComponentModule } from './personal-data/pages/document-name/document-name.module';
import { DocumentNumberComponentModule } from './personal-data/pages/document-number/document-number.module';
import { DocumentIssuingComponentModule } from './personal-data/pages/document-issuing/document-issuing.module';
import { ParentageComponentModule } from './personal-data/pages/parentage/parentage.module';
import { NationalityComponentModule } from './personal-data/pages/nationality/nationality.module';
import { MaritalStatusPageModule } from './marital-status/pages/marital-status/marital-status.module';
import { CepPageModule } from './address/pages/cep/cep.module';
import { AddressNamePageModule } from './address/pages/address-name/address-name.module';
import { AddressNumberPageModule } from './address/pages/address-number/address-number.module';
import { AdjuntPageModule } from './address/pages/address-adjunt/adjunt.module';
import { DistrictPageModule } from './address/pages/district/district.module';
import { ProfessionPageModule } from './professional-data/Pages/profession/profession.module';
import { IncomePageModule } from './income-wealth/pages/income/income.module';
import { ErrorModule } from './error/error.module';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { ExpeditionStateComponentModule } from './personal-data/pages/expedition-state/expedition-state.module';
import { BirthCountryComponentModule } from './personal-data/pages/birth-country/birth-country.module';
import { BirthStateComponentModule } from './personal-data/pages/birth-state/birth-state.module';
import { BirthCityComponentModule } from './personal-data/pages/birth-city/birth-city.module';
import { GenderComponentModule } from './personal-data/pages/gender/gender.module';
import { OriginIncomeComponentModule } from './professional-data/Pages/origin-income/origin-income.module';
import { CompanyInformationModule } from './professional-data/Pages/company-information/company-information.module';
import { PatrimonyPageModule } from './income-wealth/pages/patrimony/patrimony.module';
import { ErrorIncomePageModule } from './income-wealth/pages/error-income/error-income.module';
import { SpouseComponentModule } from './marital-status/pages/spouse/spouse.module';
import { DateTaxResidencyComponentModule } from './income-wealth/pages/date-tax-residency/date-tax-residency.module';
import { TokenService } from "./shared/service/token/token.service";
import { TokenMockService } from "./shared/service/token/token-mock.service";
import { environment } from "../environments/environment";
import { OverviewModule } from "./progress/pages/overview/overview.module";
import { SettingsModule } from "./shared/page/settings/settings.module";
import { CacheService } from './shared/service/comunicator-native/cache/v2/cache.service';
import { TokenDeviceService } from "./shared/service/token/token-device.service";
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from "@angular/common";
import { CacheNativeService } from "./shared/service/comunicator-native/cache/cache-native";
import { ClientDataComponentModule } from './client-data/pages/client-data/client-data.module';
import { NameComponentModule } from './profile-data/pages/name/name.module';
import { EmailComponentModule } from './profile-data/pages/email/email.module';
import { DateBirthComponentModule } from './personal-data/pages/date-birth/date-birth.module';
import { PhoneComponentModule } from './profile-data/pages/phone/phone.module';
import { TermsComponentModule } from "./pages/terms/terms.module";
import { DetailsModule } from './shared/page/details/details.module';
import { InvestimentBrokerModule } from './pages/investiment-broker/investiment-broker.module';
import { OverviewUserDataModule } from './progress/pages/overview-user-data/overview-user-data.module';
import { DataAnalysisComponentModule } from "./pages/data-analysis/data-analysis.module";
import { PepModule } from "./professional-data/Pages/pep/pep.module";
import { InfoDataPageModule } from "./professional-data/Pages/info-data/info-data.module";
import { BrokerRegistrationComponentModule } from "./pages/broker-registration/broker-registration.module";
import { OverviewErrorModule } from "./progress/pages/error-overview/overview-error.module";
import { FirstAccessModule } from "./pages/first-access-screen/first-access-screen.module";
import { HTTP_INTERCEPTORS, HttpHeaders } from "@angular/common/http";
import { AddressCompletedPageModule } from "./address/pages/address-completed/address-completed.module";
import { RlpComponentModule } from "./pages/rlp/rlp.module";
import { DetailsFaqModule } from "./shared/page/details-faq/details-faq.module";
import { CharonModule, CharonHttpService } from "../libs/charon";
import { Interceptor } from "./intercept";
import { IdsConfigModule } from '@ids/angular';
import { Segments } from '@ids/tools';
import { MinorModule } from './pages/minor/minor.module';
import { OverviewUserDataNotEditableModule } from './progress/pages/overview-user-data-not-editable/overview-user-data-not-editable.module';
import { NewProductsModule } from './pages/new-products/new-products.module';
import { CommunicatorNativeRemoteConfig } from './shared/service/comunicator-native/communicator-native-remote-config/communicator-native-remote-config';
import { CommunicatorNativeRemoteConfigService } from './shared/service/comunicator-native/communicator-native-remote-config/communicator-native-remote-cofing.service';
import { CaronteCustodiaService } from './shared/service/caronte-custodia/caronte-custodia.service';
import { CaronteLikertService } from './shared/service/caronte-likert/caronte-likert.service';
import { GlobalErrorHandlerService } from './shared/service/globalerror/globalerror.service';
registerLocaleData(localePt);


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    IonicModule.forRoot({ mode: 'md' }),
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DocumentTypeComponentModule,
    DocumentNameComponentModule,
    DocumentNumberComponentModule,
    DocumentIssuingComponentModule,
    ExpeditionStateComponentModule,
    BirthCountryComponentModule,
    BirthStateComponentModule,
    BirthCityComponentModule,
    GenderComponentModule,
    ParentageComponentModule,
    NationalityComponentModule,
    MaritalStatusPageModule,
    SpouseComponentModule,
    CepPageModule,
    AddressNamePageModule,
    AddressNumberPageModule,
    OverviewModule,
    AdjuntPageModule,
    DistrictPageModule,
    PepModule,
    AddressStateComponentModule,
    AddressCityComponentModule,
    ProfessionPageModule,
    IncomePageModule,
    ErrorModule,
    OriginIncomeComponentModule,
    CompanyInformationModule,
    PatrimonyPageModule,
    TaxResidencyPageModule,
    TaxResidencyCountryComponentModule,
    ErrorIncomePageModule,
    NiftModule,
    SettingsModule,
    InfoDataPageModule,
    DateTaxResidencyComponentModule,
    ClientDataComponentModule,
    NameComponentModule,
    EmailComponentModule,
    DateBirthComponentModule,
    PhoneComponentModule,
    TermsComponentModule,
    DetailsModule,
    InvestimentBrokerModule,
    OverviewUserDataModule,
    OverviewUserDataNotEditableModule,
    LoadingModule,
    DataAnalysisComponentModule,
    BrokerRegistrationComponentModule,
    OverviewErrorModule,
    FirstAccessModule,
    AddressCompletedPageModule,
    RlpComponentModule,
    DetailsFaqModule,
    NewProductsModule,
    IdsConfigModule.forRoot({
      production: environment.production,
      segment: Segments.Ion,
    }),
    CharonModule.withConfig({
      entryPoint: environment.carontePix.entryPoint,
      provider: CharonHttpService,
      httpOptions: {
        headers: new HttpHeaders({
          "x-itau-apikey": environment.carontePix.apiKey,
        }),
      },
      payloadCryptography: {
        initSessionUrl: environment.carontePix.initSessionUrl,
        protectedHeader: environment.carontePix.protectedHeader,
      },
    }),
    CharonModule.withConfig({
      entryPoint: environment.caronteCustodia.entryPoint,
      provider: CharonHttpService,
      httpOptions: {
        headers: new HttpHeaders({
          "x-itau-apikey": environment.caronteCustodia.apiKey,
        }),
      },
      payloadCryptography: {
        initSessionUrl: environment.caronteCustodia.initSessionUrl,
        protectedHeader: [environment.caronteCustodia.protectedHeader],
      },
    }),
    CharonModule.withConfig({
      entryPoint: environment.caronteLikert.entryPoint,
      provider: CharonHttpService,
      httpOptions: {
        headers: new HttpHeaders({
          "x-itau-apikey": environment.caronteLikert.apiKey,
        }),
      },
      payloadCryptography: {
        initSessionUrl: environment.caronteLikert.initSessionUrl,
        protectedHeader: [environment.caronteLikert.protectedHeader],
      },
    }),
  ],
  providers: [
    RouterGuard,
    Title,
    Keyboard,
    Interceptor,
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: TokenService, useClass: environment.tokenOriginMock ? TokenMockService : TokenDeviceService },
    { provide: CacheService, useClass: CacheNativeService },
    { provide: CommunicatorNativeRemoteConfig, useClass: CommunicatorNativeRemoteConfigService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }